export default __webpack_public_path__ + "static/media/expand-more-orange-icon.de2111e1.svg";